// @flow

// Libs
import React from 'react'
import _get from 'lodash/get'
import { FormattedMessage } from 'react-intl'

// Components
import Textfield from '@react-mdc/textfield'
import FormField from '@react-mdc/form-field'
import Select from 'react-select'

// Messages
import { messages as orderSupplies_messages } from 'hfty-order-supplies-dom'

// Style
import { styles as s } from './style'
import commonStyles from '../../commonStyles'

// Constants
import {
  US_STATES_OPTS,
  COUNTRIES_OPTS,
} from 'hfty'
import {
  PROP_ADDRESS,
  PROP_CITY,
  PROP_PROVINCE,
  PROP_POSTAL_CODE,
  PROP_COUNTRY,
  PROP_EMAIL,
  PROP_PHONE,
} from 'hfty-model-order-tests'

// Local utils
const getFieldValue = (model: Object): Function => (item: string): string =>
  _get(model, `order[${item}]`, '')
const onFieldChange = (callback: Function): Function => (event: Object) => {
  callback(_get(event, 'target.name'), _get(event, 'target.value'))
}
const renderFormField =
  (_getValue: Function, _onChange: Function): Function => (fieldName: string): React.Element<any> => {
    return (
      <FormField style={s.formField} key={`shipping-${fieldName}`}>
        <Textfield style={s.formTextField}>
          <Textfield.Label htmlFor={fieldName}>
            <FormattedMessage {...orderSupplies_messages[`OrderSupplies.form_${fieldName}`]} />
          </Textfield.Label>
          <Textfield.Input
            id={fieldName}
            name={fieldName}
            value={_getValue(fieldName)}
            onChange={(e: Function): Function => _onChange(e)}
          />
        </Textfield>
      </FormField>
    )
  }

export default function ShippingForm (props: {
  model: Object,
  onFormFieldChange: Function,
}): React.Element<any> {
  const addressFields: Array<string> = [PROP_ADDRESS, PROP_CITY]
  const contactInfoFields: Array<string> = [PROP_EMAIL, PROP_PHONE]
  const getValue = getFieldValue(props.model)
  const onChange = onFieldChange(props.onFormFieldChange)
  const formField = renderFormField(getValue, onChange)

  return (
    <form style={s.addressForm}>
      <h3 style={{...commonStyles.h3, ...s.h3}}>
        <FormattedMessage {...orderSupplies_messages[`OrderSupplies.form_shipTo`]} />
      </h3>
      { addressFields.map(formField) }
      <div style={s.selectWrapper}>
        <label
          style={s.selectLabel}
          htmlFor={PROP_PROVINCE}>State*</label>
        <Select
          clearable={false}
          name={PROP_PROVINCE}
          value={getValue(PROP_PROVINCE)}
          options={US_STATES_OPTS}
          style={s.select}
          onChange={(e: Function): Function => {
            props.onFormFieldChange(PROP_PROVINCE, e.value)
          }}
        />
      </div>
      { formField(PROP_POSTAL_CODE) }
      <div style={s.selectWrapper}>
        <label
          style={s.selectLabel}
          htmlFor={PROP_COUNTRY}>Country</label>
        <Select
          id={PROP_COUNTRY}
          clearable={false}
          name={PROP_COUNTRY}
          value={getValue(PROP_COUNTRY)}
          options={COUNTRIES_OPTS}
          style={s.select}
          onChange={(e: Function): Function => {
            props.onFormFieldChange(PROP_COUNTRY, e.value)
          }}
        />
      </div>
      { contactInfoFields.map(formField) }
    </form>
  )
}
